import { useMemo } from "react";

type Config = {
  DEBUG: string;
  ENVIRONMENT: string;
  IMAGE_PATH: string;
  FLAGS: {
    [key: string]: boolean;
  }
};

// Read from the global `window.data`, or provide a default
const configFromWindow = (window as any).config || false;

export default (): Config => {
  return useMemo(() => configFromWindow, []);
};
